import { render, staticRenderFns } from "./EstimateTemplates.vue?vue&type=template&id=4ac0473a&scoped=true&"
import script from "./EstimateTemplates.vue?vue&type=script&lang=js&"
export * from "./EstimateTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EstimateTemplates.vue?vue&type=style&index=0&id=4ac0473a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0473a",
  null
  
)

export default component.exports